import * as localStorage from 'libs/localStorage';
import russian from './russian';

let language = localStorage.getItem('language', 'ru');
export default {
	ru: russian
}[language] || russian;